import { Component, Vue } from 'vue-property-decorator';
import './top.component.scss';
import { namespace } from 'vuex-class';
import AppConstants from '@/common/constants/app.constants';

const AlertMessageStore = namespace('AlertMessageStore');
@Component({})
export default class TopComponent extends Vue {
  @AlertMessageStore.Getter
  errorMessageArray!: Array<string>;

  @AlertMessageStore.Getter
  successMessageArray!: Array<string>;

  async goto(namePage: string, workMode: number) {
    localStorage.setItem(AppConstants.STORAGE_WORK_MODE, workMode.toString());
    this.$router.push({ name: namePage });
  }

  render() {
    return (
      <div class="main-page">
        <b-row class="my-2">
          <b-col>
            <strong class="h4 font-weight-bold pl-1">アプリを選択してください</strong>
          </b-col>
        </b-row>
        <b-row
          no-gutters
          // height: (100% - setting button - header - space - (if any error message - 50) (if any success message - 50))
          style={{
            height: `calc(${100}vh - ${185}px - ${68}px - ${15}px - ${this.errorMessageArray.length > 0 ? 50 : 0}px - ${
              this.successMessageArray.length > 0 ? 50 : 0
            }px)`
          }}
        >
          <b-col cols="6" class="d-flex flex-row justify-content-center">
            <b-card
              class="card-shadow card-size cursor-pointer"
              align="center"
              onClick={() => {
                this.goto(AppConstants.NAME_MODE_SELECTION_PAGE, AppConstants.WORK_MODE_T_SORT);
              }}
            >
              <b-row class="h-100 justify-content-center align-items-center">
                <b-col class="d-flex flex-column justify-content-center align-items-center">
                  <span class="icon icon-parallel-sorting-svg"></span>
                  <strong class="text-size-20 font-weight-bold mt-1">
                    t-Sortで
                    <br />
                    商品仕分け
                  </strong>
                  <span class="text-size-14 mt-1">t-Sort Sorting</span>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          {/* <b-col cols="3" class="d-flex flex-row justify-content-center">
            <b-card class="card-shadow card-size" align="center">
              <b-row class="h-100 justify-content-center align-items-center">
                <b-col class="d-flex flex-column justify-content-center align-items-center">
                  <span class="icon icon-3d-sorter-svg"></span>
                  <strong class="text-size-20 font-weight-bold mt-1">
                    3D Sortで
                    <br />
                    商品仕分け
                  </strong>
                  <span class="text-size-14 mt-1">t-Sort 3D Sorting</span>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="3" class="d-flex flex-row justify-content-center">
            <b-card class="card-shadow card-size" align="center">
              <b-row class="h-100 justify-content-center align-items-center">
                <b-col class="d-flex flex-column justify-content-center align-items-center">
                  <span class="icon icon-patrol-sorting-svg"></span>
                  <strong class="text-size-20 font-weight-bold mt-1">
                    t-Sortで
                    <br />
                    商品ピッキング
                  </strong>
                  <span class="text-size-14 mt-1">Order Picking</span>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="3" class="d-flex flex-row justify-content-center">
            <b-card class="card-shadow card-size" align="center">
              <b-row class="h-100 justify-content-center align-items-center">
                <b-col class="d-flex flex-column justify-content-center align-items-center">
                  <span class="icon icon-box-selection-svg"></span>
                  <strong class="text-size-20 font-weight-bold mt-1">
                    満杯シュートの
                    <br />
                    箱を交換
                  </strong>
                  <span class="text-size-14 mt-1">Chute Refresh</span>
                </b-col>
              </b-row>
            </b-card>
          </b-col> */}
        </b-row>
        <b-row>
          <div class="col setting-btn px-auto m-card-horizontal">
            <button
              class="card-shadow d-flex flex-row align-items-center mx-1"
              onClick={() => {
                this.goto(AppConstants.NAME_SETTING_PAGE, AppConstants.WORK_MODE_T_SORT);
              }}
            >
              <span class="icon icon-setting-svg"></span>
              <strong class="align-items-end h3 font-weight-bold mb-0 ml-2">設定</strong>
              <span class="text-size-14 align-settings-text ml-2">Settings</span>
            </button>
          </div>
        </b-row>
        <router-view></router-view>
      </div>
    );
  }
}
